module.exports = __webpack_public_path__ + "static/media/padilha.92ffabda.jpeg";